export default "__VITE_PUBLIC_ASSET__11470618__"